import { useState } from 'react';
import Footer from '../components/Footer';

function Iban() {
  const [email, setEmail] = useState('');
  const [iban, setIban] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch('https://back-prod.weartwice.com/weartwice/iban', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, iban }),
      });

      if (response.ok) {
        setIsSuccess(true);
      } else {
        setError('An error occurred. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="w-full">
      {/* Hero Section */}
      <section className="max-h-[700px] md:min-h-screen h-screen flex flex-col justify-between relative bg-no-repeat bg-cover pb-20 py-12 md:py-16 bg-center hero-bg">
        <div className="w-full">
          <div className="container py-0 md:py-8 mx-auto w-full flex justify-center md:justify-start">
            <img
              src="/images/logo_full.svg"
              alt="WearTwice Logo"
              width="179"
              height="72"
              className="hidden md:block md:ml-4"
            />
            <img
              src="/images/logo_full_green.png"
              alt="WearTwice Logo"
              width="179"
              height="72"
              className="md:hidden"
            />
          </div>
        </div>

        <div className="container mx-auto flex flex-col h-full justify-end md:justify-center items-center gap-16 md:gap-8 px-4">
          {isSuccess ? (
            <div className="bg-white/70 backdrop-blur-sm rounded-lg p-8 max-w-md w-full">
              <h2 className="text-2xl md:text-3xl font-bold text-green-600 mb-4">
                Your IBAN has been saved successfully.
              </h2>
            </div>
          ) : (
            <div className="bg-white/70 backdrop-blur-sm rounded-lg p-8 max-w-md w-full">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
                Save your IBAN to keep your products available
              </h2>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="your@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="iban" className="block text-sm font-medium text-gray-700 mb-2">
                    IBAN
                  </label>
                  <input
                    type="text"
                    id="iban"
                    value={iban}
                    onChange={(e) => setIban(e.target.value)}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="AE07 0331 2345 6789 0123 456"
                  />
                </div>

                {error && (
                  <div className="text-red-600 text-sm">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </form>
            </div>
          )}
        </div>

      </section>

      <Footer />
    </main>
  );
}

export default Iban;
